export default {
  normal: {
    name: "Normal Schwefelarm",
    description:
      "Normal Schwefelarm ist für alle Heizungen geeignet. Es entspricht der DIN 51603-1 mit einem max. Schwefelgehalt von 0,005% und wird aus einer Raffinerie oder einem Tanklager Ihrer Region geliefert. Heizöl derselben Herkunft wird unter verschiedenen Markennamen vertrieben.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 202, 8%, 50%, 1 )",
  },
  premium: {
    name: "Normal Schwefelarm",
    description:
      "Premium Schwefelarm ist durch Additive verbessertes Normal Schwefelarm. Es schont Tank- und Heizungsanlage, führt zu geringeren Wartungskosten und riecht gut.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 354, 70%, 54%, 1 )",
  },
  climateNeutralNormal: {
    name: "CO2-Kompensiert Schwefelarm",
    description:
      "Ihre Heizölbestellung wird durch den Kauf von Klimaschutzzertifikaten klimaneutral gestellt. Nähere Informationen zu den Klimaschutzprojekten erhalten Sie von ihrem Heizölhändler.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 133, 61%, 40%, 1 )",
  },
  climateNeutralPremium: {
    name: "CO2-Kompensiert Premium Schwefelarm",
    description:
      "Mit dem Kauf von CO2-Kompensiert Premium leisten Sie einen aktiven Beitrag zum Umwelt- und Klimaschutz. Die Emissionen, die dennoch beim Heizen mit dem Premium-Heizöl klimaneutral entstehen, werden durch die Unterstützung zertifizierter Klimaschutzprojekte ausgeglichen. Nähere Informationen zu den Klimaschutzprojekten erhalten Sie von Ihrem Heizölhändler.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 133, 61%, 40%, 1 )",
  },
  bio10: {
    name: "Bio 10",
    description:
      "Bio 10 ist schwefelarmes Heizöl mit einem Anteil von 10 Prozent Bio-Öl. Es entspricht der DIN 51603-6 mit einem max. Schwefelgehalt von 0,005% und wird aus einer Raffinerie oder einem Tanklager Ihrer Region geliefert. Heizöl derselben Herkunft wird unter verschiedenen Markennamen vertrieben.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 133, 61%, 40%, 1 )",
  },
  bio10Premium: {
    name: "Premium Bio 10",
    description:
      "Premium Bio 10 ist durch Additive verbessertes Bio 10. Es schont Tank- und Heizungsanlage, führt zu geringeren Wartungskosten und riecht gut.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 133, 61%, 40%, 1 )",
  },
  bio15: {
    name: "Bio 15",
    description:
      "Bioheizöl ist schwefelarmes Heizöl mit einem biogenen Anteil von mindestens 10 oder 15 Volumenprozent.",
    icon: "tint-solid.svg",
    iconColor: "hsla( 133, 61%, 40%, 1 )",
  },
} as const;
